/**
 * The episode-start card — «окно при ЗАПУСКЕ серии».
 *
 * This replaces a CRT-and-typewriter title screen that was ours, not the
 * design's. It was invented from the early analog-horror notes and appears
 * nowhere in the 169 boards, so it is gone.
 *
 * What Figma actually specifies is quiet: the episode card art blurred behind a
 * 10% black wash, «СЕРИЯ 1» in Kaisei Tokumin 700 at 30px in #9f897e, a hairline
 * rule under it, and the episode's title in Iosevka Charon below that.
 */
export function Title({
  onStart,
  onBack,
  number,
  title,
}: {
  onStart: () => void;
  onBack: () => void;
  number: number;
  title: string;
}) {
  return (
    <div className="title">
      {/* The whole card advances, so the tap target is the screen. */}
      <button className="title-start" onClick={onStart} aria-label="Начать серию" />

      <div className="title-card">
        <p className="title-series">СЕРИЯ&nbsp;{number}</p>
        <div className="title-rule" aria-hidden="true" />
        <h1 className="title-name">{title}</h1>
      </div>

      <button className="title-back" onClick={onBack}>← В библиотеку</button>
    </div>
  );
}
